import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'app.components.WxExportApplicantModal.title',
    defaultMessage: 'Move to onboarding',
  },
  tooltip: {
    id: 'app.components.WxExportApplicantModal.tooltip',
    defaultMessage:
      'This will create or update workers in Onboard and start their onboarding process. New applicants will create new workers, while existing workers will have their data updated.',
  },
  body: {
    id: 'app.components.WxExportApplicantModal.body',
    defaultMessage:
      'This will move {count, plural, one {# applicant} other {# applicants}} to Onboard. New applicants will be created as workers, and existing workers will be updated. Onboarding communications may be sent.',
  },
  send: {
    id: 'app.components.WxExportApplicantModal.sendWebhook',
    defaultMessage: 'Move to onboarding',
  },
  submissionSuccess: {
    id: 'app.components.WxExportApplicantModal.submissionSuccess',
    defaultMessage: 'Successfully submitted applicants for onboarding',
  },
  submissionError: {
    id: 'app.components.WxExportApplicantModal.submissionError',
    defaultMessage:
      'An error occurred while submitting applicants for onboarding',
  },
});
